import MSCoverLetterEntity from '../entities/pt/PTCoverLetter.Entity';
import ReferralVisitEntity from '../entities/pt/ReferralVisit.Entity';
import ServiceTypeResponseEntity from '../entities/pt/ServiceTypeResponse.Entity';
import ServiceTypeScorecardResponseEntity from '../entities/pt/ServiceTypeScorecardResponse.Entity';
import ReferralScheduleEntity from '../entities/ReferralSchedule.Entity';
import ScorecardResponsesChartContentDataModel from './pt/ScorecardResponsesChartContentDataModel';
import ServiceTypeRequestTranslationEntity from '../entities/ServiceTypeRequestTranslation.Entity';

export default class TranslationDataModel {
    serviceTypeRequestTranslationId: number;
    referralId: number;
    serviceId: number;
    serviceTypeRequestTranslation: ServiceTypeRequestTranslationEntity;
    coverLetter: MSCoverLetterEntity;
    lastVisit: ReferralVisitEntity;
    progressSummary: string;
    response: ServiceTypeResponseEntity;
    visits: Array<ReferralVisitEntity>;
    notes: string;
    singleSchedule?: ReferralScheduleEntity;
    scorecardResponse: Array<ServiceTypeScorecardResponseEntity>;
    scorecardResponsesChartContent: Array<ScorecardResponsesChartContentDataModel>;
}
